export default __webpack_public_path__ + "static/media/2d9bcdd11143c13bdd8d39ad0b7348131581620668869.3c8ff8fd.webp";